import React, { useEffect } from "react";
import Select from 'react-select';
import PropTypes from 'prop-types';

const CustomSelect = React.forwardRef((props, ref) => {

    return (
        <Select
            classNamePrefix="select"
            placeholder={props.placeholder}
            isClearable={props.isClearable}
            isMulti={props.isMulti}
            inputValue={props.inputValue}
            name={props.name}
            // value={props.values ? Object.assign({}, props.values) : null}
            value={props.values ? props.values : null}
            onChange={(selectItems, event, name) => { props.handleChange(selectItems, event, name) }}
            onInputChange={(text) => { props.onInputChange(text) }}
            options={props.options}
            autoFocus={props.autoFocus}
            className={props.className}
            defaultValue={props.defaultValue}
        />
    )
});

CustomSelect.propTypes = {
    placeholderText: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element.isRequired
    ]),
    onChange: PropTypes.func.isRequired,
};

CustomSelect.defaultProps = {
    isClearable: true,
    autoFocus: false,
    isMulti:false
}
export default CustomSelect;
